const CarouselCard = ({props}) => {
    const {year, img, alt, title, nominated, project, status} = props;

    return (
        <div className="flex carousel__card">
            <div className="flex center text-center gap-16 w-100 nomination-card">
                <span className="options-span white fs-20">{year}</span>
                <img src={img} alt={alt} className="img nominate-logo"/>
                <span className="options-span white fs-20">{title}</span>
                <span className="options-span white fs-20">{nominated}</span>
                <span className="options-span white fs-20">{project}</span>
                <span className="options-span white fs-20">{status}</span>
            </div>
        </div>
    );
};
export default CarouselCard